import API from 'shared/connectors/config'

export const register = data => API.post('users', data)

export const getUsers = () => API.get('users')

export const editUser = data => API.put(`users/${data.uuid}`, data)

export const deleteUser = uuid => API.delete(`users/${uuid}`)
